import { queryOptions } from '@tanstack/react-query';
import { api } from './client';

/*
 * Query factories. The admin API has no push channel, so lists that change on their own
 * (operations delivery, device reports) poll; everything else refreshes on focus or after a write.
 * Keys are hierarchical: ['account', id] covers the account and its devices.
 */
export const q = {
  me: () => queryOptions({ queryKey: ['me'], queryFn: () => api.me(), staleTime: 60_000, retry: false }),
  capabilities: () => queryOptions({ queryKey: ['auth-capabilities'], queryFn: () => api.capabilities(), staleTime: Infinity }),
  overview: () => queryOptions({ queryKey: ['overview'], queryFn: () => api.overview(), refetchInterval: 30_000 }),

  accounts: (after?: string) => queryOptions({ queryKey: ['accounts', after ?? null], queryFn: () => api.accounts({ after, limit: 50 }) }),
  account: (account: string) => queryOptions({ queryKey: ['account', account], queryFn: () => api.account(account) }),
  accountDevices: (account: string) => queryOptions({ queryKey: ['account', account, 'devices'], queryFn: () => api.devices({ user: account, limit: 100 }) }),

  devices: (after?: string) => queryOptions({ queryKey: ['devices', after ?? null], queryFn: () => api.devices({ after, limit: 50 }), refetchInterval: 30_000 }),
  device: (device: string) => queryOptions({ queryKey: ['device', device], queryFn: () => api.device(device) }),
  runtime: (device: string) => queryOptions({ queryKey: ['device', device, 'runtime'], queryFn: () => api.deviceRuntime(device), refetchInterval: 15_000 }),
  policies: (device: string) => queryOptions({ queryKey: ['device', device, 'policies'], queryFn: () => api.devicePolicies(device), refetchInterval: 15_000 }),
  approvals: (device: string) => queryOptions({ queryKey: ['device', device, 'approvals'], queryFn: () => api.deviceApprovals(device) }),

  operations: () => queryOptions({ queryKey: ['operations'], queryFn: () => api.operations({ limit: 100 }), refetchInterval: 10_000 }),
  releases: () => queryOptions({ queryKey: ['releases'], queryFn: () => api.releases({ limit: 100 }) }),
  models: () => queryOptions({ queryKey: ['models'], queryFn: () => api.models() }),
  usage: () => queryOptions({ queryKey: ['models', 'usage'], queryFn: () => api.modelUsage(), refetchInterval: 60_000 }),
  admins: () => queryOptions({ queryKey: ['admins'], queryFn: () => api.admins({ limit: 100 }) }),
  audit: () => queryOptions({ queryKey: ['audit'], queryFn: () => api.auditEvents({ limit: 100 }) }),
};
